<template>
  <v-dialog v-model="opened" persistent max-width="310" light>
    <v-card v-if="currentWorkspace">
      <v-card-title class="headline"> Archive </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        Etes-vous sûr de voulir archiver le workspace "{{ currentWorkspace.name }}"? <span class="red--text font-weight-bold">Cette action est permanente et irréversible.</span>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn v-if="!loading" color="error" small @click="close"> Annuler </v-btn>
        <v-btn color="info" small :loading="loading" @click="archiveWorkspace"> Archiver </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import { useRoute } from 'vue2-helpers/vue-router';
import { useMutation } from '@vue/apollo-composable';
import { EventBus } from '../../mixins';
import { getGraphqlSchema } from '../../graphql/index';

import { changeWorkspace } from '@/utils/pwa';

const route = useRoute();
const store = useStore();
const opened = ref(false);
const workspaces = ref(store.getters.workspaces);
const loading = ref(false);

const currentWorkspace = computed(() => store.getters.workspace);

const open = () => {
  opened.value = true;
};

const close = () => {
  opened.value = false;
};
const mutation = getGraphqlSchema('archiveWorkspace');

const { mutate: archiveWorkspaceMutation, onDone, onError } = useMutation(mutation, () => ({ variables: { workspace: currentWorkspace.value.code } }));

onDone(response => {
  const curWorkspace = currentWorkspace.value;
  if (response.data.alphaArchiveWorkspace && response.data.alphaArchiveWorkspace.success) {
    const text = `Archived workspace "${curWorkspace.name}"`;
    changeWorkspace(workspaces.value.find(w => w.code === 'merch'), route);
    close();

    const options = {
      timeout: 5000,
      type: 'success'
    };
    EventBus.$emit('show-notification', { text, options });
  } else {
    if (response.data.alphaArchiveWorkspace && response.data.alphaArchiveWorkspace.error) {
      console.log('Error', response.data.alphaArchiveWorkspace.error);
    }
    const options = {
      timeout: 5000,
      type: 'error'
    };

    const text = `Failed to archive workspace ${curWorkspace.name}${response.data.alphaArchiveWorkspace.error ? `: ${response.data.alphaArchiveWorkspace.error}` : ''}`;
    EventBus.$emit('show-notification', { text, options });
    close();
  }
});

onError(error => {
  const curWorkspace = currentWorkspace.value;
  console.log('Error', error);
  const options = {
    timeout: 5000,
    type: 'error'
  };

  const text = `Failed to archive workspace ${curWorkspace.name}${error ? `: ${error}` : ''}`;
  EventBus.$emit('show-notification', { text, options });
  close();
});
const archiveWorkspace = async () => {
  const curWorkspace = currentWorkspace.value;
  if (curWorkspace.code !== 'merch') {
    loading.value = true;
    await archiveWorkspaceMutation();
    loading.value = false;
  }
};

// eslint-disable-next-line no-undef
defineExpose({ open });
</script>

<style lang="scss">
.v-card__actions {
  height: 50px;
}
</style>
